define('responsive-gameday/controllers/InningPlaysViewController',['require','exports','module','Responsive/controllers/ScrollViewController','message-service/message-service','../views/distributors/events/DistributionEvents','../views/Monitor/Events/ViewModelUpdateEvents','GameDayCore/GDUtil/tracking/GDAppTracking','./LinescoreViewController','Responsive/util/renderComplete','Responsive/util/array','GameDayCore/GDUtil/resources/GDConfig','extant/extant','../views/render/InningPlaysViewRender'],function(require,exports,module) {
    // Add private variables here
    var ScrollViewController = require("Responsive/controllers/ScrollViewController"),
        MessageService = require("message-service/message-service"),
        DistEvents = require("../views/distributors/events/DistributionEvents"),
        VMEvents = require("../views/Monitor/Events/ViewModelUpdateEvents"),
        Tracking = require("GameDayCore/GDUtil/tracking/GDAppTracking"),
        LinescoreViewController = require("./LinescoreViewController"),
        renderComplete = require("Responsive/util/renderComplete"),
        array = require("Responsive/util/array"),
        GDConfig = require("GameDayCore/GDUtil/resources/GDConfig"),
        exists = require("extant/extant"),
        InningPlaysViewRender = require( '../views/render/InningPlaysViewRender' );

    var Superclass,
        templates,
        mainRender;

    var ACTIVE_CLASS = "active";
    // Add private methods here
    // Constructor
    function InningPlaysViewController(mode) {
        var that = this;
        this.mode = mode || 'all'; // all or single
        Superclass.constructor.call(this);
        this.referenceName = "inningplays";
        this.activeClassName = "active";
        this.viewRender = new InningPlaysViewRender();
        this.activeInning = null;
        MessageService.publish("registerViewComponent", this);
    }

    // Prototype Inheritence
    ScrollViewController.spawn(InningPlaysViewController).define({
        loadView: function () {
            var that = this;

            Superclass.loadView.call(this);
            this.content = null;
            this.setClassName("InningPlaysViewController");
            this.$view=(this.view);

            /*
             * Click events for switching between teams on boxscore tab.
             */
            $(this.getView()).on('click', '.inning_nav li', function (e) {
                var inn = this.getAttribute('data-inning'),
                    $view = that.$view,
                    inningviews     = $('.inning_nav li',$view),
                    inningviewtab   = $('.inning_tabs[data-inning="'+inn+'"]',$view),
                    inningtabcontainer=$('.inning_tab_container',$view),
                    inningview = $(this);

                e.preventDefault();
                e.stopPropagation();

                if (that.activeInning !== inn) {
                    Tracking.track_inning_click();

                    that.activeInning=that.viewRender.viewState.activeInning = inn;

                    if (inningviewtab.html().trim() === "") {
                        inningtabcontainer[0].setAttribute('data-loading', true);
                    }
                    inningviews.removeClass('active');
                    inningview.addClass('active');

                    MessageService.publish(VMEvents.REQUEST_INNING_DATA,that.activeInning);
                }
                that.setScroll();
                return false
            });
        },

        viewWillAppear: function () {
            var that = this;

            // that.draw();

            Tracking.track_box_tab_activity();

            this.showOverlay();
            Superclass.viewWillAppear.call(this);

            this.viewRender.setPitchToggler(this);

            if (this.onBeat) {
                MessageService.removeListener.call(this, VMEvents.UPDATE_INNING, this.onBeat);
            }

            this.onBeat = this.onBeat || function (payload) {
                that.drawInnings(payload);
            };

        },

        viewDidAppear : function(){
            Superclass.viewDidAppear.call(this);
            MessageService.addListener.call(this, VMEvents.UPDATE_INNING, this.onBeat);
            MessageService.publish(VMEvents.REQUEST_INNING_DATA,this.activeInning);
        },

        drawInnings: function (payload) {
            var that = this;


            if (!this.isViewLoaded()) {
                return;
            }
            if(this.activeInning === null){
                this.activeInning=this.viewRender.viewState.activeInning = payload.currentInning;
            }
            this.childWrapper.innerHTML = this.viewRender.render(payload);

            renderComplete(function () {
                that.hideOverlay();
                that.setScroll();
            });
        },

        viewWillDisappear: function () {
            if (this.onBeat) {
                MessageService.removeListener.call(this,VMEvents.UPDATE_INNING, this.onBeat);
            }

            Superclass.viewWillDisappear.call(this);
        }
    });

    Superclass = InningPlaysViewController.superclass;
    return InningPlaysViewController;
});
